<template>
  <div v-if="modelo2">
    <br />
    <h4>* Banner para teste, desconsiderar.</h4>
    <!-- NEW CAROUSEL 2-->
    <div class="row" style="width: 100%; padding-top: 20px; padding-bottom: 50px">
      <div class="col-md-12">
        <div class="card" style="border-radius: 10px">
          <!--<div class="gallery js-flickity" data-flickity-options='{ "wrapAround": true }'>-->
          <div class="gallery js-flickity" data-flickity-options='{ "wrapAround": true }'>
            <div class="gallery-cell" v-for="(banner, indice) in banners" style="background-color: white">
              <img style="cursor: pointer; max-height: 520px !important" class="d-block w-100" :src="getImageBanner(banner)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END NEW CAROUSEL 2-->
  <div v-else class="row" style="width: 100%; padding-top: 20px">
    <div class="col-md-12">
      <div style="text-align: center">
        <h5 style="font-size: 17px; font-weight: bold; padding: 2px 15px 0px 5px">Próximos Leilões:</h5>
      </div>
    </div>

    <div class="col-md-12">
      <div class="card" style="border-radius: 10px">
        <!-- /.card-header -->
        <div class="card-body" style="padding: 0px 0px 0px 0px">
          <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
            <button class="glide__bullet" data-glide-dir="=8"></button>
            <ol class="carousel-indicators">
              <li
                v-for="(banner, indice) in banners"
                :key="banner"
                :value="banner"
                data-target="#carouselExampleIndicators"
                :data-slide-to="indice"
                :class="indice == 0 ? 'active' : ''"
              ></li>
            </ol>
            <div class="carousel-inner">
              <div class="carousel-item" :class="indice == 0 ? 'active' : ''" v-for="(banner, indice) in banners" :key="banner" :value="banner">
                <a :href="getUrl(banner)">
                  <img style="cursor: pointer; max-height: 520px !important" class="d-block w-100" :src="getImageBanner(banner)" />
                </a>
              </div>
            </div>
            <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
              <span class="carousel-control-custom-icon" aria-hidden="true">
                <i class="fas fa-chevron-left my-arrow"></i>
              </span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
              <span class="carousel-control-custom-icon" aria-hidden="true">
                <i class="fas fa-chevron-right my-arrow"></i>
              </span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
        <!-- /.card-body -->
      </div>
      <!-- /.card -->
    </div>
  </div>
</template>

<script>
import wppController from "../controller/wppController";
import sweetAlert from "../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import moment from "moment";
import currencyController from "../controller/currencyController";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  mixins: [wppController, sweetAlert, Swal, currencyController],

  props: ["banners", "modelo2"],

  data() {
    return {
      isLoading: false,
    };
  },

  mounted() {
    console.log("Todos os banners");
    console.log(this.banners);
  },

  methods: {
    getUrl(banner) {
      /*
      if (banner.leilao) {
        if (banner.lote_id) {
          return "/lote/" + banner.lote_id;
        } else if (banner.lotes) {
          if (banner.lotes.length > 1) {
            return "/leilao/" + banner.leilao_id + "/lotes";
          } else if (banner.lotes.length == 1) {
*/
      /* O CÓDIGO AGORA SÓ TRÁS ATIVOS
            let lote_ativo = this.buscarLoteAtivo(banner.lotes);

            if (lote_ativo >= 0) {
              return "/lote/" + lote_ativo.id;
            } else {
              return "/leilao/" + banner.leilao_id + "/lotes";
            }
            */
      /*
            return "/lote/" + banner.lotes[0].id;
          } else {
            return "/leilao/" + banner.leilao_id + "/lotes";
          }
        }
      }*/

      return banner.url;
    },

    buscarLoteAtivo(lotes) {
      for (let i = 0; i < lotes.length; i++) {
        if (lotes[i].ativo == 1) {
          return lotes[i];
        }
      }

      return -1;
    },

    getImageBanner(banner) {
      if (banner.path.includes("rochaleiloes2")) {
        return process.env.MIX_VUE_APP_S3_BASE2_URL + banner.path + "/" + banner.arquivo;
      } else if (banner.path.includes("rochaleiloes") || banner.arquivo.includes("banner_")) {
        return process.env.MIX_VUE_APP_S3_BASE_URL + banner.path + "/" + banner.arquivo;
      } else {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + banner.path + "/" + banner.arquivo;
      }
    },
  },
};
</script>

<style>
.my-arrow {
  background-color: rgb(148, 148, 148, 0.5);
}

.my-arrow:hover {
  background-color: rgb(148, 148, 148, 0.8);
}
</style>
